<template lang="pug">
.pre-footer
  .container
    .pre-footer__wrapper
      .row.footer-second-line
        logoAfisha.white.invisible(v-if="isGuru === false")
        logoGuru.white.invisible(v-if="isGuru === true")
        .right
          // .button__dd
            .button.button__outline.button__gray.button__icon_right
              span {{$i18n.locale}}
              icon(name="downArrow")
            .button__dd_child.toup-dd
              .button__dd_child_scroll
                .button__dd_child_item.wsn(v-for="lng in langs",
                  @click="switchLang(lng.code)") {{ lng.name }}
          span.social(:class="{'alone': !isAfishaDomain}")
            span.social__item(v-if="isAfishaDomain" @click="toLink('https://vk.com/24afishaby', '_blank')")
              icon(name="vk")
            // span.social__item(@click="toLink('https://www.facebook.com/24afisha.by', '_blank')")
              icon(name="fb")
            span.social__item(@click="toLink(socials ? socials.instagramUrl : 'https://www.instagram.com/24afisha.by', '_blank')")
              icon(name="instagram")
      ul.row.footer-menu.footer__top(v-if="this.$store.state.layout && this.$store.state.layout.footer && this.$store.state.layout.footer.top && this.$store.state.layout.footer.top.length")
        li(v-for="i in footerByLocale(this.$store.state.layout)")
          a.footer-menu__item(v-bind:href="i.url.replace('24guru', '24afisha')", target="_blank") {{ i.name }}

      //-.left
        //- a.button.button__icon.button__icon_left(href="//m.24guru.by")
          icon(name="mobile")
          span {{$t('msgs.mobVersion')}}
        a.button.button__icon.button__icon_left.preFooter__left(v-if="phone", :href="'tel:' + phone")
          icon(name="phone")
          span {{ phone }}
</template>

<script>
import LogoAfisha from 'components@/_logo/afisha';
import LogoGuru from 'components@/_logo/guru';
import icon from 'components@/icons';

export default {
  name: 'PreFooterCab',
  components: {
    icon,
    LogoAfisha,
    LogoGuru,
  },
  data: () => ({
    isGuru: false,
    isAfishaDomain: true,
  }),
  computed: {
    layout() {
      return this.$store.state.layout;
    },
    langs() {
      if (this.layout) {
        return this.layout.langs;
      }
      return 'ru';
    },
    copyright() {
      if (this.$store.state.layout) {
        return this.$store.state.layout.copyright;
      }
      return 'Layout on null';
    },
    phone() {
      if (this.$store.state.layout) {
        return this.$store.state.layout.phone;
      }
      return 'Layout of null';
    },
    address() {
      if (this.$store.state.layout) {
        return this.$store.state.layout.bank.info;
      }
      return 'Layout of null';
    },
    currentLang() {
      return this.$store.state.locale;
    },
    metaImage() {
      return this.$store.state.layout ? this.$store.state.layout.logoUrl : null;
    },
    region() {
      if (this.$store.state.cities.currentCity && this.$store.state.cities.currentCity.slug) {
        return this.$store.state.cities.currentCity.slug;
      }
      return this.$store.state.cities.defaultSlug;
    },
    lang() {
      return this.$store.state.locale;
    },
    socials() {
      if (this.$store.state.layout.socials && Object.keys(this.$store.state.layout.socials).length) {
        return this.$store.state.layout.socials;
      }
      return null;
    }
  },
  methods: {
    switchLang(newLocale) {
      this.$i18n.locale = newLocale;
      window.localStorage.setItem('lang', newLocale);
      window.location.reload();
    },
    toLink(link, target) {
      if (window) {
        window.open(link, target);
      }
    },
    foregnUrlPages(slug) {
      let isProd = false;
      if (process.browser && window) {
        isProd = window.location.href.match(/^https:\//);
      }
      const current = isProd ? 'https://24guru.by' : 'http://24.arcom.of.by';
      return `${current}/${this.lang}/pages/${slug}`;
    },
    footerByLocale(layout) {
      if (layout[`footer_${(localStorage.getItem('lang') ? localStorage.getItem('lang') : 'ru')}`]) {
        return layout[`footer_${(localStorage.getItem('lang') ? localStorage.getItem('lang') : 'ru')}`].top;
      }
      return layout.footer.top;
    }
  },
  mounted() {
    if (window.location.href.match(/localhost/) || window.location.href.match(/guru.ge/)) this.isAfishaDomain = false;
    if (window.location.href.includes('24guru')) this.isGuru = true;
  },
};
</script>

<style lang="scss" scoped>
.links {
  margin-right: auto;

  .link + .link {
    margin-left: 30px;
  }
}

.icons {
  margin-bottom: 23px;

  .icon + .icon {
    margin-left: 8px;
  }
}
.footer__top {
  padding: 0;
  background-color: unset;
  //margin-top: 1rem;
}
.pre-footer {
  padding: 3rem 0 1rem;
}
.footer-menu__item {
  color: #2f80ed;
  font-size: 10px;
}
.footer-menu__item:hover {
  color: #666;
}
.footer-second-line {
  margin: 0;
  @media screen and (max-width: 60rem) {
    padding: 0;
    //margin-top: 1rem;
  }
}
.preFooter__left {
  padding: 0;
}
ul.row.footer-menu {
  @media screen and (max-width: 60rem) {
    padding-left: 0;
    margin-top: 1rem;
  }
}
.invisible {
  opacity: 0;
}
</style>
